goog.provide('el8.appchart.visitNote.cdsDetailDialog');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.visitNote.cdsDetailDialog');

/**
 * This dialog presents details on a particular CDS measure
 * that are required by MU / CMS. Custom measures may not
 * have this detail, and whether or not this dialog is accessible
 * is controlled by a user preference ("cdsDisplaySupDiag")
 */
el8.appchart.visitNote.cdsDetailDialog = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'Clinical Reminder Details',
        autoHeight: true,
        width: 600,
        modal: false,
        position: 'center',
        contentFn: el8.template.appchart.visitNote.cdsDetailDialog.content,
        showXButton: true
    });

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        $('.cds-detail-dialog-content').load(
            '/quality_measures/documentation/'+spec.nqfCode+'/'
        );
        /*
            Doing this to give the page a little time to load the 
            content and then adjust based on the newly loaded content
        */
        setTimeout(function(){
            that.adjustPosition();
        }, 250);
    };

    return that;

})();
